import { createI18nLoader } from '../create-i18n-loader';

export const i18nLoader = createI18nLoader(
  async (lang) => import(`./${lang}.json`)
);
